export const getRootElement = () => document.getElementById("root");
